import { Box, Container, makeStyles, Paper, Tab, Theme, Typography } from '@material-ui/core';
import { TabContext, TabPanel } from '@mui/lab';
import TabList from '@mui/lab/TabList';
import CustomersReviewHub from 'components/customers-review-hub/components/customers-review-hub';
import React from 'react';
import Customers from './components/Customers/Customers';

const useStyles = makeStyles((theme: Theme): any => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

function CustomersPage(): React.ReactElement {
  const classes: any = useStyles();

  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, tabValue: string) => {
    setValue(tabValue);
  };

  return (
    <Container className={classes.container} maxWidth="lg">
      <TabContext value={value}>
        <Paper square style={{ marginBottom: 10 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="customer tabs" style={{ fontSize: 'small' }}>
              <Tab label="Customers" value="1" />
              <Tab label="Data Review" value="2" />
            </TabList>
          </Box>
        </Paper>

        <TabPanel value="1" style={{ padding: 0 }}>
          <Customers />
        </TabPanel>

        <TabPanel value="2" style={{ padding: 0 }}>
          <CustomersReviewHub />
        </TabPanel>
      </TabContext>
    </Container>
  );
}

export default CustomersPage;
